import { Stack } from "@chakra-ui/react";

import {
  MainPageHeader,
  MainPageContent,
  MainPageAlertBanner,
} from "../components/features/MainPage";
import { PageContentLayout } from "../components/shared/PageContentLayout";

export function MainPage() {
  return (
    <Stack id="mainPage" spacing={4} minH="100svh">
      <MainPageHeader />

      <PageContentLayout>
        <MainPageAlertBanner />
        <MainPageContent />
      </PageContentLayout>
    </Stack>
  );
}
